import React, { useState, useContext, useEffect, useRef } from "react";
import "./RemoteFittingNew.css";
import { ForwardFittingContext } from "./ForwardFittingContext.js";
import { getErrorByField } from "../../Api/auth.js";
import HeaderAdmin from "../../Components/HeaderAdmin/Header.jsx";
import { FaPlay } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import VideoUpload from "../DashboardComponents/Video/VideoUpload.js";
import VideoUpload2 from "../DashboardComponents/Video/VideoUpload2.js";
import { Form } from "react-bootstrap";
import { RiCloseFill } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import CameraModal from "../DashboardComponents/ImageUpload/CameraModel.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../../Api/iron.js";
import Loader2 from "../DashboardComponents/Loader/Loader2.jsx";
import {
  uploadimagetoattachment,
  getunsubmittedfittingdata,
  updatevalidatedata,
  updateirontestdata,
  saveattachementdata,
  updatelaststedata,
  getunsubmittedstudionfittingdata
} from "../../Api/contact.js";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { IoClose } from "react-icons/io5";
import { API_URL } from "../../Api/config.js";
import UserInfo from "./RemortFittingComp/UserInfo.jsx";
import SwingData from "./RemortFittingComp/SwingData.jsx";
import IronData from "./RemortFittingComp/IronData.jsx";
import IronStudioData from "./RemortFittingComp/IronStudioData.jsx";
import BallData from "./RemortFittingComp/BallData.jsx";

import { getCurrentUser } from "../../Api/auth.js";
import NoteData from "./RemortFittingComp/NoteData.jsx";
import TopOne from "./RemortFittingComp/TopOne.jsx";
import TopTwo from "./RemortFittingComp/TopTwo.jsx";
import { Row, Col } from 'react-bootstrap';
import TopOne1 from "./RemortFittingComp/TopOne1.jsx";
import UserInfo1 from "./RemortFittingComp/UserInfo1.jsx";
import TopTwo2 from "./RemortFittingComp/TopTwo.jsx";
import { getcountriesforfitter, getstates, getcities, } from '../../Api/iron'

function RemoteFittingStudio() {
  const { remotefittingdata, setRemotefittingdata, updateremotefitting } =
    useContext(ForwardFittingContext);

  const params = useParams();
  const [remoteData, setRemoteData] = useState(null);

  const [textAreaData, setTextAreaData] = useState(null);
  const [userdata, setUserdata] = useState('');

  const [studioshow, setstudioShow] = useState(false);

  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add("remotefittingnewdesign");

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove("mremotefittingnewdesign");
    };
  }, []);

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("currenttab");
    return savedTab ? savedTab : "link";
  });

  const [inputValue, setInputValue] = useState("");
  const [remoteData2, setRemoteData2] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    dexterity: "",
    country: "",
    state:"",
    city:""
  });



  const [user_id, setuser_id] = useState(0);

  const [projectid, setProjectId] = useState(null);

  useEffect(() => {
    getunsubmittedstudionfittingdata({ _id: params.id })
      .then((data) => {
        if (data?.code === 200) {
          // setRemotefittingdata(data.data);
          if (data.data.status === false) {
            setProjectId(null);
          } else {
            setFormData(data.data.userdata);
            setRemoteData(data.data.data.remotefittingdata);
            setProjectId(data.data.data._id);
            setRemotefittingdata(data.data.data.remotefittingdata);
            setRemoteData2(data.data.data);
            setstudioShow(!!data.data.data.studio_fitting);
            getallstatefunc(data.data.userdata.country)
            getallcityfunc(data.data.userdata.state)
          }
        } else {
          console.log(data.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [params]);

  useEffect(() => {
    console.log("remotefittingdata", remotefittingdata);
  }, [remotefittingdata]);


  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add('remotefittingnewdesign');

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove('remotefittingnewdesign');
    };
  }, []);


  useEffect(() => {
    const getCurrentUserdata = getCurrentUser();

    if (getCurrentUserdata && getCurrentUserdata.user) {
      setUserdata(getCurrentUserdata.user);
    } else {
      console.error("Current user data is null or undefined");
    }
    getallcountry();

  }, []);


  const [isMobile, setIsMobile] = useState(true);

  // Check if the screen width is less than or equal to 768px (mobile size)
  const checkDevice = () => {
    setIsMobile(window.innerWidth <= 990); // You can adjust the width value as per your needs
  };

  useEffect(() => {
    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);





  const [stateLoading, setStateLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);

  const [countrylist, setCountrylist] = useState([]);
  const [statelist, setStatelist] = useState([]);
  const [citylist, setCitylist] = useState([]);

  const getallcountry = () => {
    getcountriesforfitter()
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          const data = response.data.data;
          setCountrylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallstatefunc = (country_id) => {
    setStateLoading(true)
    const data = {
      country_id: country_id,
    };
    getstates(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setStateLoading(false)
          const data = response.data.data;
          setStatelist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getallcityfunc = (state_id) => {
    setCityLoading(true);
    const data = {
      state_id: state_id,
    };
    getcities(data)
      .then((response) => {
        if (!response.data.status) {
          console.log(response.data.message);
        } else {
          setCityLoading(false);
          const data = response.data.data;
          setCitylist(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };



  return (
    <>
      {/* {remoteData !== null && remotefittingdata ? ( */}




      {
        isMobile ? (
          <div className="design_show_mobile">
            <div className="main-page-body-content-header">
              <HeaderAdmin />
            </div>
            <div>
              <TopOne1 />
              <TopTwo2 />
              <UserInfo1 user={formData} statelist={statelist} citylist={citylist} countrylist={countrylist}/>
              <SwingData remoteData={remotefittingdata} remoteFittingQueriesId={projectid} />
              {
                studioshow ? (<><IronStudioData remoteData={remotefittingdata} projectid={projectid} /></>) : (<><IronData remoteData={remotefittingdata} projectid={projectid} /></>)
              }
              <BallData remoteData={remotefittingdata} projectid={projectid} />
              <NoteData userdata={userdata} remoteData={remotefittingdata} projectid={projectid} user={formData} />
            </div>
          </div>
        ) : (
          <div className="design_hide_mobile">
            <div className="main-page-body-content-header">
              <HeaderAdmin />
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className='col-12 col-lg-7 scrollable-section'>
                  <TopTwo />
                  <SwingData remoteData={remotefittingdata} remoteFittingQueriesId={projectid} />
                  {
                    studioshow ? (<><IronStudioData remoteData={remotefittingdata} projectid={projectid} /></>) : (<><IronData remoteData={remotefittingdata} projectid={projectid} /></>)
                  }
                  <BallData remoteData={remotefittingdata} projectid={projectid} />
                  <NoteData userdata={userdata} remoteData={remotefittingdata} projectid={projectid} user={formData} />
                </div>
                <div className='col-12 col-lg-5 scrollable-section'>
                  <TopOne />
                  <UserInfo user={formData} statelist={statelist} citylist={citylist} countrylist={countrylist}/>
                </div>
              </div>
            </div>
          </div>
        )
      }


      <>






        {/* <>
            <TopOne />
            
            <TopTwo />
              <UserInfo user={formData} />
            </>
            <SwingData remoteData={remotefittingdata} remoteFittingQueriesId={projectid} />
            <IronData remoteData={remotefittingdata} projectid={projectid} />
            <BallData remoteData={remotefittingdata} projectid={projectid} />
            <NoteData userdata={userdata} remoteData={remotefittingdata} projectid={projectid} /> */}



      </>
      {/* ) : (
        <div style={errorStyle}>
          <Loader2 />
          <p>Loading...</p>
        </div>
      )} */}
    </>
  );
}

const errorStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  textAlign: "center",
  backgroundColor: "#98ea24",
  color: "#000000",
  padding: "20px",
  fontSize: "25px",
  fontWeight: 600,
};

export default RemoteFittingStudio;
